import React from 'react';
import './payment-card.scss';
import { SVGS } from '../../assets';
import '../../conversations/_conversation-utils.scss';
import { MessageKebabMenu } from '../message-kebab-menu/message-kebab-menu';

export const PaymentCardComp: React.FC = () => {
  return (
    <div className="payment-card-comp">
      <div className="payment-card-comp__header">
        <div className="payment-card-comp__header-left">
          <span className="font-semibold payment-card-comp__header-left-title">
            <img src={SVGS.PaymentGreen} alt="" />
            Payment
          </span>
          <div className={`payment-card-comp-status-details`}>Sent</div>
        </div>
        <div className="payment-card-comp__header-right">
          <div className="font-regular payment-card-comp__header-right-time">
            <img src={SVGS.Clock} alt="" /> 12:32 PM
          </div>
          <MessageKebabMenu />
        </div>
      </div>
      <div className="payment-card-comp__body-wrapper">
        <div className="payment-card-comp-message-with-image">
          <img src={'https://picsum.photos/241/122'} alt="" className="" />
          <div className="message-with-image-message font-regular">Payment</div>
        </div>
        <img src={SVGS.Whatsapp} alt="" width={24} />
      </div>
      <div className="payment-card-comp__extra-details">
        <div className="payment-card-comp__extra-details-item">
          <div className="payment-card-comp__extra-details-item-heading">
            UTR No
          </div>
          <div className="payment-card-comp__extra-details-item-value">
            #320414967679
          </div>
        </div>
        <div className="payment-card-comp__extra-details-item">
          <div className="payment-card-comp__extra-details-item-heading">
            Payment Mode
          </div>
          <div className="payment-card-comp__extra-details-item-value">UPI</div>
        </div>
        <div className="payment-card-comp__extra-details-item">
          <div className="payment-card-comp__extra-details-item-heading">
            Amount
          </div>
          <div className="payment-card-comp__extra-details-item-value">
            ₹39,433
          </div>
        </div>
      </div>
      <div className="payment-card-comp__footer">
        <span className="order-status font-regular">
          Your action is required!
        </span>
        <button className="btn btn-primary font-regular">
          Submit Payment <img src={SVGS.ArrowDown} />
        </button>
      </div>
    </div>
  );
};
